import * as API from '../'
import $const from "../../common/constant";

export default {
  /**
   * 轮播图列表
   */
  index: params => {
    return API.GET(`/mall/enterprisebase/index`, params)
  },
  search: params => {
    return API.GET(`/mall/search`, params)
  }
}




// WEBPACK FOOTER //
// ./src/api/mall/mall.js